import React, { useEffect, useState } from 'react';
import { CheckCircleIcon } from 'lucide-react';
const PURCHASES = [{
  name: 'Matías',
  city: 'Buenos Aires'
}, {
  name: 'Nicolás',
  city: 'Córdoba'
}, {
  name: 'Rodrigo',
  city: 'Rosario'
}, {
  name: 'Facundo',
  city: 'Mendoza'
}, {
  name: 'Tomás',
  city: 'La Plata'
}, {
  name: 'Ezequiel',
  city: 'Santa Fe'
}, {
  name: 'Agustín',
  city: 'Tucumán'
}, {
  name: 'Leandro',
  city: 'Neuquén'
}, {
  name: 'Germán',
  city: 'Mar del Plata'
}, {
  name: 'Sebastián',
  city: 'Salta'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(PURCHASES[0]);
  useEffect(() => {
    let timeoutId: NodeJS.Timeout;
    const showPopup = () => {
      const randomPerson = PURCHASES[Math.floor(Math.random() * PURCHASES.length)];
      setCurrentPurchase(randomPerson);
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
      const nextDelay = Math.random() * (15000 - 8000) + 8000 + 4000;
      timeoutId = setTimeout(showPopup, nextDelay);
    };
    const initialTimeout = setTimeout(() => {
      showPopup();
    }, 5000);
    return () => {
      clearTimeout(initialTimeout);
      clearTimeout(timeoutId);
    };
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-40" style={{
    animation: 'slideInLeft 0.3s ease-out'
  }} data-id="element-15">
      <style data-id="element-16">{`
        @keyframes slideInLeft {
          from { transform: translateX(-100%); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }
      `}</style>
      <div className="bg-white rounded-lg shadow-xl border border-gray-100 p-4 flex items-center gap-3 max-w-xs md:max-w-sm" data-id="element-17">
        <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-18">
          <CheckCircleIcon className="w-6 h-6 text-green-600" data-id="element-19" />
        </div>
        <div data-id="element-20">
          <p className="text-sm font-bold text-gray-900" data-id="element-21">
            {currentPurchase.name} de {currentPurchase.city}
          </p>
          <p className="text-xs text-gray-500" data-id="element-22">
            acaba de comprar MegaPack Físico Visible
          </p>
          <p className="text-xs text-green-600 font-medium mt-0.5" data-id="element-23">
            Hace unos instantes
          </p>
        </div>
      </div>
    </div>;
}